export const MAX_FILE_SIZE = 10 * 1024 * 1024;
